// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"Menu_dropdownMenu__3nzma","open":"Menu_open__G_Tpm","dropdownItem":"Menu_dropdownItem__60Mll","active":"Menu_active__e0q8g"};